import { render } from "./wxAuthorize.vue?vue&type=template&id=d8eaaa96&scoped=true"
import script from "./wxAuthorize.vue?vue&type=script&lang=js"
export * from "./wxAuthorize.vue?vue&type=script&lang=js"

import "./wxAuthorize.vue?vue&type=style&index=0&id=d8eaaa96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d8eaaa96"

export default script